import React, { useState } from "react";
import Navbar from "../components/ui/Navbar";
import AlmaPage from "./storage/AlmacenPage";
import IngresosPage from "./storage/IngresosPage";
import SalidasPage from "./storage/SalidasPage";
import OrdenesPage from "./storage/OrdenesPage";
import TransfersPage from "./storage/TransfersPage";
import WarehousesPage from "./storage/WarehousesPage";
import { hasPermission } from "../utils/permissions";
import {
  Boxes,
  PackagePlus,
  PackageMinus,
  ClipboardList,
  ArrowLeftRight,
  Warehouse,
} from "lucide-react";

const SECTIONS = [
  { key: "almacen", label: "Stock", icon: Boxes, perm: "almacen.ver" },
  {
    key: "ingresos",
    label: "Ingresos",
    icon: PackagePlus,
    perm: "almacen.ingresar",
  },
  {
    key: "salidas",
    label: "Salidas",
    icon: PackageMinus,
    perm: "almacen.bajar",
  },
  {
    key: "ordenes",
    label: "Órdenes de compra",
    icon: ClipboardList,
    perm: "compras.ver",
  },
  {
    key: "transfers",
    label: "Transferencias",
    icon: ArrowLeftRight,
    perm: "almacen.ingresar",
  },
  { key: "storages", label: "Almacenes", icon: Warehouse, perm: "almacen.ver" },
];

const renderSection = (section) => {
  switch (section) {
    case "almacen":
      return <AlmaPage />;
    case "ingresos":
      return <IngresosPage />;
    case "salidas":
      return <SalidasPage />;
    case "ordenes":
      return <OrdenesPage />;
    case "storages":
      return <WarehousesPage />;
    case "transfers":
      return <TransfersPage />;
    default:
      return <AlmaPage />;
  }
};

const AlmacenPage = () => {
  const visible = SECTIONS.filter((s) => !s.perm || hasPermission(s.perm));
  const [section, setSection] = useState(visible[0]?.key ?? "almacen");

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="container mx-auto px-4 py-6 pt-20 md:pt-28">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 bg-blue-600 rounded-xl">
            <Boxes className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Almacén</h1>
            <p className="text-sm text-gray-500">
              Gestión de stock, movimientos y almacenes
            </p>
          </div>
        </div>

        {/* Tab nav */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-4">
          <nav className="flex overflow-x-auto scrollbar-hide px-2 py-2 gap-1">
            {visible.map(({ key, label, icon: Icon }) => {
              const active = section === key;
              return (
                <button
                  key={key}
                  onClick={() => setSection(key)}
                  className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all ${
                    active
                      ? "bg-blue-600 text-white shadow-sm"
                      : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                  }`}
                >
                  <Icon
                    className={`h-4 w-4 ${active ? "text-white" : "text-gray-400"}`}
                  />
                  {label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 sm:p-6">
          {renderSection(section)}
        </div>
      </div>

      <style>{`
        .scrollbar-hide::-webkit-scrollbar { display: none; }
        .scrollbar-hide { scrollbar-width: none; }
      `}</style>
    </div>
  );
};

export default AlmacenPage;
